import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export const Pagination = ({ currentPage, totalItems, pageSize, onPageChange, testIdPrefix = 'page' }) => {
  const totalPages = Math.ceil(totalItems / pageSize);
  if (totalItems <= pageSize) return null;

  const visiblePages = Array.from({ length: totalPages }, (_, i) => i + 1)
    .filter(p => p === 1 || p === totalPages || Math.abs(p - currentPage) <= 2)
    .reduce((acc, p, idx, arr) => {
      if (idx > 0 && p - arr[idx - 1] > 1) acc.push('...');
      acc.push(p);
      return acc;
    }, []);

  return (
    <div className="flex items-center justify-between mt-4 px-1" data-testid={`${testIdPrefix}-pagination`}>
      <p className="text-xs text-slate-400">
        Showing {((currentPage - 1) * pageSize) + 1}–{Math.min(currentPage * pageSize, totalItems)} of {totalItems}
      </p>
      <div className="flex items-center gap-1">
        <button
          onClick={() => onPageChange(Math.max(1, currentPage - 1))}
          disabled={currentPage === 1}
          data-testid={`${testIdPrefix}-prev`}
          className="p-1.5 rounded border border-slate-700 disabled:opacity-30 hover:bg-slate-800/60 transition-colors"
        >
          <ChevronLeft className="h-4 w-4" />
        </button>
        {visiblePages.map((p, idx) =>
          p === '...' ? (
            <span key={`dot-${idx}`} className="px-1 text-slate-400 text-xs">...</span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              data-testid={`${testIdPrefix}-${p}`}
              className={`min-w-[32px] h-8 rounded text-xs font-semibold transition-colors ${
                currentPage === p
                  ? 'bg-blue-600 text-white'
                  : 'border border-slate-700 text-slate-300 hover:bg-slate-800/60'
              }`}
            >
              {p}
            </button>
          )
        )}
        <button
          onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
          disabled={currentPage >= totalPages}
          data-testid={`${testIdPrefix}-next`}
          className="p-1.5 rounded border border-slate-700 disabled:opacity-30 hover:bg-slate-800/60 transition-colors"
        >
          <ChevronRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
